import ConfirmAccountPage from "./confirm-account.page";

export default ConfirmAccountPage;
